import React from 'react';

const AxisCards = ({ vm }) => {
  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '16px',
      marginBottom: '32px'
    },
    card: {
      padding: '20px',
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      transition: 'transform 0.2s, box-shadow 0.2s',
      cursor: 'default'
    },
    cardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '12px'
    },
    title: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#1e293b',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    badge: {
      padding: '2px 8px',
      fontSize: '0.75rem',
      fontWeight: '600',
      borderRadius: '4px',
      backgroundColor: '#fef3c7',
      color: '#92400e'
    },
    score: {
      fontSize: '1.25rem',
      fontWeight: '700',
      color: '#6366f1'
    },
    weakScore: {
      fontSize: '1.25rem',
      fontWeight: '700',
      color: '#ea580c'
    },
    scoreLabel: {
      fontSize: '0.875rem',
      color: '#94a3b8',
      fontWeight: '400'
    },
    description: {
      fontSize: '0.875rem',
      color: '#64748b',
      lineHeight: '1.5',
      margin: 0
    }
  };

  return (
    <div style={styles.container}>
      {vm.eixos.map(eixo => {
        const isWeak = eixo.notaRadar < 3.1;
        
        return (
          <article 
            key={eixo.key} 
            style={styles.card}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
            }}
          >
            <div style={styles.header}>
              <h4 style={styles.title}>
                {eixo.rotulo}
                {isWeak && <span style={styles.badge}>Lacuna</span>}
              </h4>
              <div>
                <span style={isWeak ? styles.weakScore : styles.score}>
                  {eixo.notaRadarFmt}
                </span>
                <span style={styles.scoreLabel}>/6,0</span>
              </div>
            </div>
            <p style={styles.description}>{eixo.descricao}</p>
            <p style={{
              fontSize: '0.75rem',
              color: '#64748b',
              margin: '8px 0 0 0',
              lineHeight: '1.4',
              fontStyle: 'italic'
            }}>
              Pontuação 0-6: {isWeak ? 'Abaixo de 3,1 indica necessidade de melhoria' : 'Acima de 3,1 indica nível adequado'}
            </p>
          </article>
        );
      })}
    </div>
  );
};

export default AxisCards;